<template>
  <div class="md-layout">
    <md-card>
      <md-card-header
        v-if="!everythingLoaded"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon class="load-rotate">hourglass_empty</md-icon>
        </div>
        <h4 class="title">Laden</h4>
      </md-card-header>
      <md-card-header
        v-if="everythingLoaded"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon>date_range</md-icon>
        </div>
        <h4 class="title">
          Beschikbaarheid van chauffeur
          <u
            >{{ this.driver.firstName }}
            <template v-if="this.driver.lastNamePrefix !== ''">
              {{ this.driver.lastNamePrefix }}
            </template>
            {{ this.driver.lastName }}</u
          >
          in de <u>{{ this.selectedWeekTypeName }}</u> weken, route
          <u>{{ this.selectedRouteName }}</u
          >, dienst <u>{{ this.selectedShiftName }}</u>
        </h4>
      </md-card-header>
      <md-card-content v-if="everythingLoaded">
        <div class="md-group">
          <md-button
            :class="[{ 'md-success': selectedWeekType === 'odd' }, 'md-sm']"
            v-on:click="changeSelectedWeekType('odd')"
            >Oneven weken
          </md-button>
          <md-button
            :class="[{ 'md-success': selectedWeekType === 'even' }, 'md-sm']"
            v-on:click="changeSelectedWeekType('even')"
            >Even weken
          </md-button>
        </div>

        <br />

        <div class="md-group">
          <md-button
            v-for="route in routes"
            :key="route.id"
            :class="[{ 'md-success': selectedRouteId === route.id }, 'md-sm']"
            v-on:click="changeSelectedRoute(route.id)"
            >{{ route.name }}
          </md-button>
        </div>

        <br />

        <div class="md-group">
          <md-button
            v-for="shift in this.getShiftsBySelectedRoute()"
            :key="shift.id"
            :class="[{ 'md-success': selectedShiftId === shift.id }, 'md-sm']"
            v-on:click="changeSelectedShift(shift.id)"
            >{{ shift.name }}
          </md-button>
        </div>

        <time-line plain type="simple" v-if="dataPeriods.length > 0">
          <time-line-item-driver-available-period
            inverted
            badge-type="primary"
            badge-icon="schedule"
            v-for="(period, index) in dataPeriods"
            :key="index"
            v-model="dataPeriods[index]"
            :data="period"
            :selectableAvailabilityTypes="selectableAvailabilityTypes"
            @handleDelete="handleDelete"
          ></time-line-item-driver-available-period>
        </time-line>

        <div class="alert alert-success" v-if="dataPeriods.length === 0">
          <span
            >Er is geen beschikbaarheid opgegeven voor de
            <u>{{ this.selectedWeekTypeName }}</u> weken, route
            <u>{{ this.selectedRouteName }}</u
            >, dienst <u>{{ this.selectedShiftName }}</u></span
          >
        </div>

        <ul class="legend">
          <li><h5>Legenda</h5></li>
          <li
            v-for="(status, statusIndex) in selectableAvailabilityTypes"
            :key="statusIndex"
          >
            <md-icon :style="getIconStyleColorByStatus(statusIndex)"
              >{{ getIconByStatus(statusIndex) }}
            </md-icon>
            {{ status.label }}
          </li>
        </ul>
      </md-card-content>
      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          class="md-primary"
        >
          Terug
        </md-button>
        <md-button
          native-type="button"
          @click.native.prevent="handleAddNew"
          class="md-success"
          >Toevoegen
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import DriversMethods from "./DriversMethods.js";
import { TimeLine, TimeLineItemDriverAvailablePeriod } from "@/components";

export default {
  components: {
    TimeLine,
    TimeLineItemDriverAvailablePeriod
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    dataPeriods: function() {
      var periods = [];

      if (this.availablePeriods === undefined) {
        return periods;
      }

      for (var i in this.availablePeriods) {
        if (this.availablePeriods[i].id.length !== 36) {
          continue;
        }

        if (
          this.availablePeriods[i].weekOddEven != this.selectedWeekTypeNumber
        ) {
          continue;
        }

        if (
          this.availablePeriods[i].route_ids.indexOf(this.selectedRouteId) ===
          -1
        ) {
          continue;
        }
        if (
          this.availablePeriods[i].shift_ids.indexOf(this.selectedShiftId) ===
          -1
        ) {
          continue;
        }

        periods.push(this.availablePeriods[i]);
      }

      let currentSortDir = "asc";
      let currentSort = "dayOfTheWeek";

      periods = periods.sort((a, b) => {
        let modifier = 1;
        if (currentSortDir === "desc") modifier = -1;
        if (a[currentSort] < b[currentSort]) return -1 * modifier;
        if (a[currentSort] > b[currentSort]) return 1 * modifier;
        return 0;
      });

      return DriversMethods.reformatLoadedShiftPeriods(
        DriversMethods.groupPeriods(periods)
      );
    },
    selectedWeekTypeName: function() {
      if (this.selectedWeekType === "odd") {
        return "oneven";
      }

      return "even";
    },
    selectedWeekTypeNumber: function() {
      if (this.selectedWeekType === "odd") {
        return 1;
      }

      return 0;
    },
    selectedRouteName: function() {
      if (this.selectedRouteId === null) {
        return "";
      }

      for (let i in this.routes) {
        if (this.routes[i].id == this.selectedRouteId) {
          return this.routes[i].name;
        }
      }

      return "";
    },
    selectedShiftName: function() {
      if (this.selectedShiftId === null) {
        return "";
      }

      for (let i in this.shifts) {
        if (this.shifts[i].id == this.selectedShiftId) {
          return this.shifts[i].name;
        }
      }

      return "";
    }
  },
  data() {
    return {
      driver: {
        id: "",
        firstName: "",
        lastNamePrefix: "",
        lastName: "",
        email: ""
      },
      daysOfTheWeek: {
        1: "Maandag",
        2: "Dinsdag",
        3: "Woensdag",
        4: "Donderdag",
        5: "Vrijdag",
        6: "Zaterdag",
        7: "Zondag"
      },
      loaded: {
        driver: false,
        groups: false,
        routes: false,
        shifts: false,
        shiftRoutes: false,
        availablePeriods: false,
        selectableAvailabilityTypes: false
      },
      groups: [],
      routes: [],
      shifts: [],
      availablePeriods: [],
      selectedWeekType: "odd",
      selectedRouteId: null,
      selectedShiftId: null,
      selectableAvailabilityTypes: [],
      requestsRemaining: 0
    };
  },
  methods: {
    loadRouteGroups() {
      this.$http.get(this.$apiBaseUrl + "routes/groups").then(
        response => {
          this.loaded.groups = true;
          this.groups = response.data.routeGroups;
        },
        response => {}
      );
    },
    loadRoutes() {
      this.$http.get(this.$apiBaseUrl + "routes").then(
        response => {
          let routes = response.data.routes;

          for (var i = 0; i < routes.length; i++) {
            routes[i].order = routes[i].order.toString();
            routes[i].isreserve = routes[i].isreserve.toString();
            routes[i].shiftIds = [];

            if (this.selectedRouteId === null) {
              this.selectedRouteId = routes[i].id;
            }
          }

          this.loaded.routes = true;
          this.routes = routes;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van routes",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadShifts() {
      this.$http.get(this.$apiBaseUrl + "shifts").then(
        response => {
          let shifts = response.data.shifts;

          for (let i in shifts) {
            shifts[i]["routeIds"] = [];
          }

          this.loaded.shifts = true;
          this.shifts = shifts;
          this.loadShiftsRoutes();
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van diensten",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadShiftsRoutes() {
      this.$http.get(this.$apiBaseUrl + "shifts/routes").then(
        response => {
          let routeIds = {};
          for (let s in this.shifts) {
            routeIds[this.shifts[s].id] = [];
          }

          for (let shiftId in response.data.shifts_routes) {
            for (let i in response.data.shifts_routes[shiftId]) {
              routeIds[shiftId].push(
                response.data.shifts_routes[shiftId][i].id
              );
            }
          }

          for (let s in this.shifts) {
            this.shifts[s]["routeIds"] = routeIds[this.shifts[s].id];
          }

          this.loaded.shiftRoutes = true;
          this.changeSelectedRoute(this.selectedRouteId);
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van diensten",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadDriver(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "drivers/" + id).then(
        response => {
          this.driver.firstName = response.data.driver.firstName;
          this.driver.lastNamePrefix = response.data.driver.lastNamePrefix;
          this.driver.lastName = response.data.driver.lastName;
          this.driver.email = response.data.driver.email;

          this.requesting = false;
          this.loaded.driver = true;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van chauffeurs", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadAvailablePeriods(userId) {
      this.$http
        .get(this.$apiBaseUrl + "drivers/" + userId + "/availableperiods")
        .then(
          response => {
            this.loaded.availablePeriods = true;
            this.availablePeriods = response.data.driverPeriods;
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van beschikbaarheidsperioden",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    loadSelectableAvailabilityTypes() {
      this.$http
        .get(this.$apiBaseUrl + "drivers/selectableavailabilitytypes")
        .then(
          response => {
            this.loaded.selectableAvailabilityTypes = true;
            this.selectableAvailabilityTypes =
              response.data.selectableAvailabilityTypes;
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van beschikbaarheidsperioden",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    changeSelectedWeekType(weekType) {
      this.selectedWeekType = weekType;
    },
    changeSelectedRoute(routeId) {
      this.selectedRouteId = routeId;

      let shifts = this.getShiftsBySelectedRoute();

      if (shifts.length === 0) {
        this.selectedShiftId = null;

        return;
      }

      for (let i in shifts) {
        if (shifts[i].id === this.selectedShiftId) {
          return;
        }
      }

      this.selectedShiftId = shifts[0].id;
    },
    changeSelectedShift(shiftId) {
      this.selectedShiftId = shiftId;
    },
    getShiftsBySelectedRoute() {
      let shifts = [];

      for (let i in this.shifts) {
        if (this.shifts[i].routeIds.indexOf(this.selectedRouteId) === -1) {
          continue;
        }

        shifts.push(this.shifts[i]);
      }

      this.currentSort = "order";
      this.currentSortOrder = "asc";
      shifts = this.sortAll(shifts);

      return shifts;
    },
    goBack() {
      this.$router.go(-1);
    },
    handleAddNew() {
      this.$router.push(
        "/drivers/edit/" +
          this.$route.params.userId +
          "/availablePeriod/add/" +
          this.selectedRouteId +
          "/" +
          this.selectedShiftId +
          "/" +
          this.selectedWeekType
      );
    },
    handleDelete(periodIds) {
      this.requestsRemaining = periodIds.length;
      let availablePeriods = this.availablePeriods;

      for (let i in periodIds)
        this.$http
          .delete(this.$apiBaseUrl + "drivers/availableperiods/" + periodIds[i])
          .then(
            response => {
              this.requestsRemaining--;

              for (let p in availablePeriods) {
                if (availablePeriods[p].id === periodIds[i]) {
                  availablePeriods.splice(p, 1);
                }
              }

              if (this.requestsRemaining <= 0) {
                this.availablePeriods = availablePeriods;
                this.notifyVue(
                  "Beschikbaarheid succesvol verwijderd",
                  "check",
                  "success",
                  5000
                );
              }
            },
            response => {
              if (response.status === 403) {
                this.notifyVue(
                  "U heeft geen rechten voor het verwijderen van beschikbaarheid",
                  "add_alert",
                  "danger",
                  0
                );
              } else {
                this.notifyVue(
                  "Onbekende fout tijdens het verwijderen van beschikbaarheid",
                  "report_problem",
                  "danger",
                  0
                );
              }
            }
          );
    },
    getIconByStatus(status) {
      return this.selectableAvailabilityTypes[status].icon;
    },
    getIconStyleColorByStatus(status) {
      return (
        "color: " +
        this.selectableAvailabilityTypes[status].color +
        " !important;"
      );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  mounted() {
    this.loadRouteGroups();
    this.loadRoutes();
    this.loadShifts();
    this.loadDriver(this.$route.params.userId);
    this.loadAvailablePeriods(this.$route.params.userId);
    this.loadSelectableAvailabilityTypes();
  }
};
</script>

<style lang="css" scoped>
ul.legend {
  list-style-type: none;
}
div.alert.alert-success {
  margin-top: 1em;
}
</style>
